// Captures the session's landing referrer + UTM once so report views can be
// attributed to organic-search / shared / direct traffic sources.
const KEY = "aa_session_src";

export const getSessionSource = () => {
  try {
    const cached = sessionStorage.getItem(KEY);
    if (cached) return JSON.parse(cached);
    const params = new URLSearchParams(window.location.search);
    const utm = {};
    ["utm_source", "utm_medium", "utm_campaign"].forEach((k) => {
      const v = params.get(k);
      if (v) utm[k] = v;
    });
    const src = { referrer: document.referrer || "", utm };
    sessionStorage.setItem(KEY, JSON.stringify(src));
    return src;
  } catch {
    return { referrer: "", utm: {} };
  }
};
